import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

// import required modules
import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import "./HomeBanner.css";
import { Skeleton } from "antd";
import { Link, useHistory } from "react-router-dom";
export default function HomeBanner({ banners }) {
  const history = useHistory();
  return (
    <Swiper
      pagination={{
        dynamicBullets: true,
        clickable: true,
      }}
      effect={"fade"}
      autoplay={{
        delay: 5555000,
        disableOnInteraction: false,
      }}
      modules={[EffectFade, Autoplay, Pagination]}
      className="mySwiper home-banner-slider">
      {banners.length > 0 ? (
        <>
          {banners?.map((data, index) => {
            return (
              <SwiperSlide key={`Homebanne${index}`}>
                {data.slug !== null ? (
                  <a href={data?.slug}>
                    <img
                      alt="Banner Image"
                      src={
                        window.innerWidth > 992
                          ? data?.image.split("$")[0].split("#")[0]
                          : data?.image.split("$")[1].split("#")[0]
                      }
                      className="img-fluid"
                      // onClick={() => history.push('/category/occasion/fathers-day-21st-jun')}
                    />
                  </a>
                ) : (
                  <img
                    alt="Banner Image"
                    src={
                      window.innerWidth > 992
                        ? data?.image.split("$")[0].split("#")[0]
                        : data?.image.split("$")[1].split("#")[0]
                    }
                    className="img-fluid"
                    // onClick={() => history.push('/category/occasion/fathers-day-21st-jun')}
                  />
                )}
              </SwiperSlide>
            );
          })}
        </>
      ) : (
        <Skeleton.Image alt="Banner Image" className="img-fluid w-100 " />
      )}
    </Swiper>
  );
}
